module.exports = __webpack_public_path__ + "img/J3.fa48bea8.png";